export var isStorageAvailable = (function () {
    try {
        var storage = window.localStorage;
        if (!storage) {
            return false;
        }
        var x = '__storage_test__';
        storage.setItem(x, x);
        var available = x === storage.getItem(x);
        storage.removeItem(x);
        return available;
    }
    catch (e) {
        return false;
    }
})();
var localStorageErrorText = 'XDomainStorage is not working due to absence of LocalStorage.';
if (!isStorageAvailable) {
    console.warn(localStorageErrorText);
}
export var getLocalStorageFailPromise = function () {
    return Promise.reject(localStorageErrorText);
};
export var onBodyReady = function (cb) {
    if (document.body) {
        cb();
    }
    else {
        var _func_1 = function () {
            if (document.body) {
                cb;
            }
            else {
                setTimeout(_func_1, 100);
            }
        };
        setTimeout(_func_1, 0);
    }
};
